import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesRequest,
} from '../../../shared/repositories/favorites/v1/delete-offer-from-favorites';
import { fetchAddFavorite } from '../../../shared/repositories/favorites/v1/add-favorite';
import {
  trackingActionAddFromCardJG,
  trackingActionRemoveFromCardJK,
} from '../../../shared/actions/analytics/trackFavorite';
import { setIsFavorite } from '../../../shared/slices/newbuildingReducer';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../shared/types/redux';
import { getNewbuildingId } from '../../../shared/selectors/newbuilding';
import { getGALabel } from '../../../shared/selectors/newbuilding/getGALabel';

export const removeFavorite = createAsyncThunk<void, void, IThunkApi>(
  'favorites/removeFavorite',
  async (_, { dispatch, extra: { httpApi }, getState }) => {
    const state = getState();
    const newbuildingId = getNewbuildingId(state);
    const gaLabel = getGALabel(state);

    const parameters: TDeleteOfferFromFavoritesRequest = {
      dealType: 'sale' as const,
      entityType: 'newbuilding' as const,
      entityId: newbuildingId,
    };

    trackingActionRemoveFromCardJK(gaLabel, newbuildingId);

    const response: { statusCode: number } = await fetchDeleteOfferFromFavorites({ httpApi, parameters });

    if (response.statusCode === 200) {
      dispatch(setIsFavorite(false));
    }
  },
);

export const addFavorite = createAsyncThunk<void, void, IThunkApi>(
  'favorites/addFavorite',
  async (_, { dispatch, extra: { httpApi }, getState }) => {
    const state = getState();
    const newbuildingId = getNewbuildingId(state);
    const gaLabel = getGALabel(state);

    const parameters: TDeleteOfferFromFavoritesRequest = {
      dealType: 'sale' as const,
      entityType: 'newbuilding' as const,
      entityId: newbuildingId,
    };

    trackingActionAddFromCardJG(gaLabel, newbuildingId);

    const response: { statusCode: number } = await fetchAddFavorite({ httpApi, parameters });

    if (response.statusCode === 200) {
      dispatch(setIsFavorite(true));
    }
  },
);
